import React, { useState, useEffect } from "react";
import axios from "axios";
import messageImg from "../images/message.png";
import telephone from "../images/telephone.png";
import location from "../images/location.png";
import ReCAPTCHA from "react-google-recaptcha";

const API_BASE_URL = "https://contact.globalsurveysolutions.com";
// const API_BASE_URL = "http://192.168.100.16:8003";

function ContactUs() {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mob, setMob] = useState("");
  const [message, setMessage] = useState("");

  const [capSub, setCapSub] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertMsg, setAlertMsg] = useState(null);

  // Fixed Service ID
  const service = 13;

  useEffect(() => {
    setTimeout(() => {
      const captchaInput = document.querySelector(
        "#g-recaptcha-response"
      );

      if (captchaInput) {
        captchaInput.setAttribute("required", "required");
      }
    }, 1000);
  }, []);

  function checkInput() {
    const submitBtn = document.querySelector(".formSubmitBtn");

    if (
      firstName &&
      lastName &&
      email &&
      message &&
      capSub
    ) {
      submitBtn?.setAttribute(
        "class",
        "formSubmitBtn activeBtn"
      );
    } else {
      submitBtn?.setAttribute(
        "class",
        "formSubmitBtn"
      );
    }
  }

  useEffect(() => {
    checkInput();
  }, [firstName, lastName, email, message, capSub]);

  async function onFormSubmit(event) {
    event.preventDefault();

    if (
      !firstName ||
      !lastName ||
      !email ||
      !message ||
      !capSub
    ) {
      return;
    }

    setLoading(true);

    const payload = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone_number: mob,
      service: service,
      message: message,
    };

    try {
      await axios.post(
        `${API_BASE_URL}/api/inquiry/quote/GSS/`,
        payload
      );

      setAlertMsg({
        type: "success",
        text: "Your inquiry has been submitted successfully!",
      });

      // Reset form
      setEmail("");
      setFirstName("");
      setLastName("");
      setMob("");
      setMessage("");
      setCapSub(false);

      document.querySelector(".contactUsForm").reset();

      setTimeout(() => {
        setAlertMsg(null);
      }, 3000);
    } catch (error) {
      console.error(error);

      setAlertMsg({
        type: "error",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="contactUs" id="contactUs">
      <div className="contactCont">
        <div className="contactDetails">
          <div>
            <div className="imgDiv">
              <img src={location} alt="" />

              <div>Address</div>
            </div>

            <div className="details">
              3rd Floor, GM IT Park Sector 142 <br />
              Noida, Uttar Pradesh Pin - 201304
              India
            </div>
          </div>

          <div>
            <div className="imgDiv">
              <img src={telephone} alt="" />

              <div>Let's Talk</div>
            </div>

            <div className="details">
              +91 9899061991
            </div>
          </div>

          <div>
            <div className="imgDiv">
              <img src={messageImg} alt="" />

              <div>General Support</div>
            </div>

            <div className="details">
              contactus@globalsurveysolutions.com
            </div>
          </div>

          <div>
            <div className="imgDiv">
              <img src={messageImg} alt="" />

              <div>For Sales</div>
            </div>

            <div className="details">
              rfq@globalsurveysolutions.com
            </div>
          </div>
        </div>

        <div className="contactForm">
          <div className="formHead">
            Send Us A Message
          </div>

          {alertMsg && (
            <div
              style={{
                background:
                  alertMsg.type === "success"
                    ? "#16a34a"
                    : "#dc2626",
                color: "#fff",
                padding: "10px",
                borderRadius: "5px",
                marginBottom: "15px",
                textAlign: "center",
              }}
            >
              {alertMsg.text}
            </div>
          )}

          {loading && (
            <div
              style={{
                marginBottom: "15px",
                textAlign: "center",
              }}
            >
              Submitting...
            </div>
          )}

          <form
            onSubmit={onFormSubmit}
            className="contactUsForm"
          >
            <div className="label">
              TELL US YOUR NAME*
            </div>

            <input
              type="text"
              placeholder="First Name"
              onChange={(e) =>
                setFirstName(e.target.value)
              }
              onKeyUp={checkInput}
              name="firstName"
              required
            />

            <input
              type="text"
              onKeyUp={checkInput}
              placeholder="Last Name"
              onChange={(e) =>
                setLastName(e.target.value)
              }
              name="LastName"
              required
            />

            <div style={{ display: "flex" }}>
              <div style={{ width: "40%" }}>
                <div className="label">
                  ENTER YOUR EMAIL*
                </div>

                <input
                  style={{ width: "100%" }}
                  type="email"
                  name="email"
                  onChange={(e) =>
                    setEmail(e.target.value)
                  }
                  placeholder="Eg. example@email.com"
                  required
                  onKeyUp={checkInput}
                />
              </div>

              <div style={{ width: "40%" }}>
                <div className="label">
                  ENTER YOUR PHONE NUMBER
                </div>

                <input
                  onKeyUp={checkInput}
                  type="number"
                  style={{
                    width: "100%",
                    marginLeft: "20px",
                  }}
                  onChange={(e) =>
                    setMob(e.target.value)
                  }
                  name="phone"
                  placeholder="Eg. +91 0000000000"
                />
              </div>
            </div>

            <div className="label">MESSAGE*</div>

            <textarea
              onKeyUp={checkInput}
              placeholder="Write us a message"
              onChange={(e) =>
                setMessage(e.target.value)
              }
              name="message"
              required
            ></textarea>

            <br />

            <div className="captchaCont">
              <ReCAPTCHA
                required
                sitekey="6LeX_QQkAAAAAB0QIYpGkTCl_AeLwQfShypwTL93"
                onChange={() => {
                  setCapSub(true);
                  checkInput();
                }}
              />
            </div>

            <div className="buttonCont">
              <button
                className="formSubmitBtn"
                type="submit"
                disabled={loading}
              >
                {loading ? "SUBMITTING..." : "SUBMIT"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;